export function getPeriodText(period: number) {
  switch (period) {
    case 1:
      return '1 day'
    default:
      return `${period} days`
  }
}
